import { TimeGapVO } from '../../../vo/core/timegap.vo';
import { ExternalAPI } from '../../../model/external-api';
import { Model } from '../../../model/model';
import { TimeGapWrapper, BasicCriteria, BasicScenario, TimeGap } from '@wizeoo/akm-message-lib';
import { WizCommand } from '@wizeoo/akm-component-lib';
import { WIZ_COMMAND_METHOD} from '@wizeoo/akm-core-lib';
import { ViewData } from '../../../model/view.data';

/**
 * Appels time gap (Find)

 */
export class TimegapCmd extends WizCommand<TimeGapWrapper> {
  
  protected model: Model = null;

  constructor(model: Model) {
    super();
    this.model = model;
  } 

  public sourceVO: TimeGapVO = null; // mémorisation de la source pour maj sur retour service


  /** retourne un wrapper pre-alimenté */
  public timegapWrapper(): TimeGapWrapper {
    const wrapper: TimeGapWrapper = new TimeGapWrapper();
    wrapper.criteria = new BasicCriteria();
    wrapper.criteria.domain = ViewData.wildcardDomain;
    wrapper.criteria.businessUnitCode = ViewData.wildcardDomain;
    wrapper.criteria.manageDeprecated = true;
    wrapper.criteria.manageDeleted = true;
    wrapper.scenario = new BasicScenario();
    wrapper.scenario.languageCode = this.model.currentLocaleCode;
    return wrapper;
  }



  /** chargement initial. Tout le domaine */
  public find(): TimegapCmd {
    const wrapper: TimeGapWrapper = this.timegapWrapper();
    wrapper.method = WIZ_COMMAND_METHOD.FIND;
    this.configureRemote(ExternalAPI.TIMEGAP_API, wrapper);
    return this;
  }

  /** sur retour, traitement selon la méthode */
  public wizResult() {
    super.wizResult();

    const wrapper: TimeGapWrapper = this.result;
    // convertion de la liste de retour en liste de LanguageVO
    const timegaps: TimeGapVO[] = wrapper.entities.map((element: TimeGap) => new TimeGapVO(element));

    this.model.timegapList = timegaps;
  }
}
